import { render, staticRenderFns } from "./transformer-title.vue?vue&type=template&id=44d0ddf6&scoped=true"
import script from "./transformer-title.vue?vue&type=script&lang=js"
export * from "./transformer-title.vue?vue&type=script&lang=js"
import style0 from "./transformer-title.vue?vue&type=style&index=0&id=44d0ddf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d0ddf6",
  null
  
)

export default component.exports